import { paths } from '@perpay-web/fintech/props/appPaths';
import {
    PAYCHEX_SSO_FLOW_CONFIG,
    PAYCHEX_SSO_FLOW_TYPE,
} from '@perpay-web/fintech/types/payrollProviderTypes';

export const PAYCHEX_SSO_FLOW_CONFIG_MAP: {
    [key in PAYCHEX_SSO_FLOW_TYPE]: PAYCHEX_SSO_FLOW_CONFIG;
} = {
    [PAYCHEX_SSO_FLOW_TYPE.SIGNUP_NEW_USER]: {
        successPath: paths.spendingLimit.path,
        employerInfoPage: {
            title: 'Last step before seeing your spending limit!',
            subtitle:
                'Instead of relying on your credit history, we use your current income information to determine your custom spending limit',
            buttonText: 'View Spending Limit',
        },
    },
    [PAYCHEX_SSO_FLOW_TYPE.SIGNUP_EXISTING_USER]: {
        successPath: paths.dashboard.path,
        employerInfoPage: {
            title: "We've updated your employer information",
            subtitle:
                "We've made changes to keep your account details up to date. Please review your information below. If you need to change your employment information you can always change it later. ",
            buttonText: 'Dashboard',
        },
    },
    [PAYCHEX_SSO_FLOW_TYPE.BOX_AD]: {
        successPath: paths.dashboard.path,
        employerInfoPage: {
            title: "We've updated your employer information",
            subtitle:
                "We've made changes to keep your account details up to date. Please review your information below. If you need to change your employment information you can always change it later. ",
            buttonText: 'Continue',
        },
        successScreen: {
            title: 'Paychex Account Connected!',
            subtitle:
                "Your Paychex account is securely linked! You're ready to experience a better way to pay.",
            subHeader: 'Up next',
            footerButtons: [
                {
                    text: 'Dashboard',
                    href: paths.dashboard.path,
                    action: 'primary',
                },
            ],
        },
        introScreen: true,
    },
};
